import React, { useState } from 'react'
import Table from '../../../components/Table'
import { MenuComportamento } from '../../../components/Menus'
import { Badge } from 'reactstrap'

const TIPO_BADGE = {
  info: { color: 'info', label: 'Informação' },
  success: { color: 'success', label: 'Sucesso' },
  warning: { color: 'warning', label: 'Aviso' },
  danger: { color: 'danger', label: 'Erro / Crítico' },
}

export default ({ alertas, pageProperties, onTableChange, onEdit, onDelete, onToggleStatus }) => {
  const [columns] = useState([
    {
      dataField: 'acoes',
      text: '',
      formatter: (cell, row) => acoesFormatter(cell, row),
    },
    {
      dataField: 'titulo',
      text: 'Título',
    },
    {
      dataField: 'tipo',
      text: 'Tipo',
      formatter: (cell) => {
        const t = TIPO_BADGE[cell] || { color: 'secondary', label: cell }
        return <Badge color={t.color}>{t.label}</Badge>
      },
    },
    {
      dataField: 'ativo',
      text: 'Status',
      formatter: (cell) =>
        cell ? <Badge color="success">Ativo</Badge> : <Badge color="secondary">Inativo</Badge>,
    },
    {
      dataField: 'is_private',
      text: 'Visibilidade',
      formatter: (cell) =>
        cell ? <Badge color="warning">Privado</Badge> : <Badge color="info">Público</Badge>,
    },
    {
      dataField: 'data_inicio',
      text: 'Início',
      formatter: (cell) => (cell ? new Date(cell).toLocaleString('pt-BR') : '—'),
    },
    {
      dataField: 'data_fim',
      text: 'Fim',
      formatter: (cell) => (cell ? new Date(cell).toLocaleString('pt-BR') : '—'),
    },
  ])

  const acoesFormatter = (cell, row) => {
    return (
      <MenuComportamento
        actions={[
          {
            label: 'Alterar',
            icon: 'far fa-edit',
            onClick: () => onEdit(row),
          },
          {
            label: row.ativo ? 'Inativar' : 'Reativar',
            icon: row.ativo ? 'fas fa-ban' : 'fas fa-check',
            onClick: () => onToggleStatus(row),
          },
          {
            label: 'Excluir',
            icon: 'fas fa-trash',
            onClick: () => onDelete(row.id),
          },
        ]}
      />
    )
  }

  return (
    <Table
      columns={columns}
      data={alertas}
      classes="table-sm table-v-middle"
      condensed
      pageProperties={pageProperties}
      onTableChange={onTableChange}
    />
  )
}
